import Cookie from './cookie';
export const defaultTimeout = 30000;
export const highRepeatInterval = 2000;
export const lowRepeatInterval = 5000;
export function createQueryFromObject(object) {
    return Object.keys(object).reduce((memo, key) => {
        return memo + (memo ? '&' : '') + key + '=' + object[key];
    }, '');
}
export function processResponse(response) {
    if (response.status >= 200 && response.status < 300) {
        return {
            statusCode: 0,
            data: response.data
        };
    }
    return {
        statusCode: 1,
        msg: response.data && response.data.error && response.data.error.split
            ? response.data.error.split(' ')[0]
            : 'request_error'
    };
}
// TODO: reduce cognitive complexity
// eslint-disable-next-line sonarjs/cognitive-complexity
export function processError(error) {
    // Server fatal error
    if (error.response && error.response.status === 500) {
        return {
            statusCode: 5,
            msg: 'server_error'
        };
    }
    // Action not allowed error
    if (error.response && (error.response.status === 403 || error.response.status === 401)) {
        return {
            statusCode: 4,
            msg: error.response.data.error === 'blocked_temporarily' ||
                error.response.data.error === 'blocked_permanently'
                ? error.response.data.error
                : 'auth_error'
        };
    }
    // Non critical request error
    if (error.response) {
        if (error.response.data.errors && error.response.data.errors.length) {
            return {
                statusCode: 1,
                msg: error.response.data.errors[0]
            };
        }
        if (error.response.data.error && error.response.data.error.split) {
            return {
                statusCode: 1,
                msg: error.response.data.error.split(' ')[0]
            };
        }
        if (error.response.data.messages && error.response.data.messages.length) {
            return {
                statusCode: 1,
                msg: error.response.data.messages[0]
            };
        }
        if (error.response.data.message) {
            return {
                statusCode: 1,
                msg: error.response.data.message
            };
        }
        return {
            statusCode: 1,
            msg: error.response.data.message && error.response.data.message.split
                ? error.response.data.message.split(' ')[0]
                : 'request_error'
        };
    }
    else if (error.request) {
        // Connection error
        return {
            statusCode: 2,
            msg: 'connection_error'
        };
    }
    // Unknown error
    return {
        statusCode: 3,
        msg: error.message && error.message.split ? error.message.split(' ')[0] : 'unknown_error'
    };
}
export function processPrismicError(error) {
    switch (error.status) {
        case 500:
            return {
                statusCode: 4,
                msg: 'server_error'
            };
        case 403:
            return {
                statusCode: 4,
                msg: 'auth_error'
            };
        case 400:
            return {
                statusCode: 1,
                msg: 'request_error'
            };
        default:
            return {
                statusCode: 3,
                msg: 'unknown_error'
            };
    }
}
export function privateRequestParamsCommerce(accessParams, additional = {}, requestTimeout = defaultTimeout) {
    return Object.assign({
        headers: {
            Authorization: 'Bearer ' + accessParams.access_token,
            'X-Hero-Account': accessParams.selected_account_id || ''
        },
        timeout: requestTimeout
    }, additional);
}
export function privateRequestParams(accessParams, additional = {}) {
    return Object.assign({
        headers: {
            Authorization: 'Bearer ' + accessParams.access_token,
            'X-Hero-Client': window._CLIENT_TYPE,
            'X-Hero-Account': accessParams.selected_account_id || ''
        },
        timeout: defaultTimeout
    }, additional);
}
// TODO what's the catch with the token here? (there's no one in common-js similar helper)
// until investigated and resolved, there's another helper below - publicRequestParams2
export function publicRequestParams(accessParams, additional = {}) {
    return Object.assign({
        headers: {
            Authorization: 'Bearer ' + accessParams.access_token,
            'X-Hero-Client': window._CLIENT_TYPE,
            'Content-Type': 'application/json'
        },
        timeout: defaultTimeout
    }, additional);
}
export function publicRequestParams2(additional = {}) {
    return Object.assign({
        headers: {
            'X-Hero-Client': window._CLIENT_TYPE,
            'Content-Type': 'application/json'
        },
        timeout: defaultTimeout
    }, additional);
}
// TODO refactor if needed (quick solution)
export function privateBackofficeRequestParams(accessParams, additional = {}) {
    const CF_Authorization = Cookie.getCookie('CF_Authorization');
    return Object.assign({
        headers: {
            Authorization: 'Bearer ' + accessParams.access_token,
            'X-Hero-Client': window._CLIENT_TYPE,
            'X-Hero-Account': accessParams.selected_account_id || '',
            'Cf-Access-Jwt-Assertion': CF_Authorization
        },
        timeout: defaultTimeout
    }, additional);
}
export function publicBackofficeRequestParams(accessParams, additional = {}) {
    const CF_Authorization = Cookie.getCookie('CF_Authorization');
    return Object.assign({
        headers: {
            Authorization: 'Bearer ' + accessParams.access_token,
            'X-Hero-Client': window._CLIENT_TYPE,
            'Content-Type': 'application/json',
            'Cf-Access-Jwt-Assertion': CF_Authorization
        },
        timeout: defaultTimeout
    }, additional);
}
//# sourceMappingURL=index.js.map